import React from "react";
import { StatisticWidget, StatisticWidgetTable, StatisticWidgetHeader } from "../../components/StatisticWidget";
import { StatisticWidgetTitle as Title, StatisticWidgetFilter as Filter } from "../../components/StatisticWidget";
import { StatisticWidgetDate as Date, StatisticWidgetSource as Source } from "../../components/StatisticWidget";
import { StatisticWidgetRow as Row, StatisticWidgetCell as Cell } from "../../components/StatisticWidget";
import { usePrices } from "../../shared/hooks/usePrices";
import messages from "./messages";
import { FormattedMessage } from "react-intl";

export default () => {
  const [prices] = usePrices();

  return (
    <>
      {prices.map((tableData, index) => {
        let formatedDate = `${tableData.date && tableData.date.toDateString()}`;
        if (tableData.date && tableData.id === "pricewidget_monthly") {
           // TODO: Заменить на более правильное решение [rows: 19-21]
          const month = tableData.date.toDateString().split(' ')[1];
          const year = tableData.date.toDateString().split(' ')[3];
          formatedDate = `${month} ${year}`;
        }
        return (
          <StatisticWidget key={index}>
            <StatisticWidgetHeader>
              <Title>
                {tableData.name}:
              </Title>
              {/* <Filter /> */}
            </StatisticWidgetHeader>
            <Date>
              {formatedDate} <FormattedMessage {...messages.datePostFix} />
            </Date>
            <StatisticWidgetTable>
              {tableData.prices.map((row, ind) => {
                const rowName = tableData.id === "pricewidget_monthly" ? (row.name.split(',')[0] || '').trim() : row.name;
                return (
                  <Row key={ind}>
                    <Cell >{rowName}</Cell>
                    <Cell >${row.current.toFixed(0)}</Cell>
                    <Cell >${row.peak.toFixed(0)}</Cell>
                  </Row>
                );
              })}
            </StatisticWidgetTable>
            <Source>
              <FormattedMessage {...messages.tableFooterSource} />
              {tableData.source}
            </Source>
          </StatisticWidget>
        );
      })}
    </>
  );
};
